import { PaletteMode } from '@mui/material'
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

const ebmPapstColors = {
    blue: '#007cbc',
    'mo-blue': '#62798b',
    'dark-green': '#00a633',
    'light-green': '#a3ba1e',
    yellow: '#fbb900',
    orange: '#cb0d0d'
}

const getThemeOptions = (mode: PaletteMode) => ({
    palette: {
        mode,
        primary: {
            main: '#fff'
        },
        secondary: {
            main: ebmPapstColors['mo-blue']
        },
        warning: {
            main: ebmPapstColors.yellow
        },
        success: {
            main: ebmPapstColors['dark-green']
        },
        error: {
            main: ebmPapstColors.orange
        }
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '--TextField-brandBorderColor': ebmPapstColors['mo-blue'],
                    '--TextField-brandBorderHoverColor': ebmPapstColors['mo-blue'],
                    '--TextField-brandBorderFocusedColor': ebmPapstColors['mo-blue'],
                    '& label.Mui': {
                        color: mode === 'light' ? ebmPapstColors['mo-blue'] : '#e6e6e6'
                    },
                    '& label.Mui-focused': {
                        color: mode === 'light' ? ebmPapstColors['mo-blue'] : '#e6e6e6'
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    borderColor: mode === 'light' ? ebmPapstColors['mo-blue'] : '#e6e6e6',
                },
                root: {
                    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: mode === 'light' ? ebmPapstColors['mo-blue'] : '#e6e6e6',
                    },
                    [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: mode === 'light' ? ebmPapstColors['mo-blue'] : '#e6e6e6',
                    },
                },
            }
        }
    }
})

export { ebmPapstColors, getThemeOptions }